import { Layer, LayerGroup } from "../types";
import { ConstraintsCategory } from "../../Constraints/types";
import { RoadAndTrafficLayerType, TrafficLayerType } from "../layer_types/TrafficLayerType";
import Feature from "src/js/stores/user/Feature";
import { AdoptedRoadsLayerType } from "../layer_types/AdoptedRoadsLayerType";

export const ADOPTED_ROADS: Layer = {
  id: "ADOPTED_ROADS",
  layerType: AdoptedRoadsLayerType,
  title: "Adopted roads",
  requiredFeatureAccess: [Feature.adoptedRoadsLayer],
  toggleable: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  group: LayerGroup.TRAFFIC,
  icon: "lt-layer-adopted-roads",
  description: "Adoption status for the road network",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 15,
  },
  layerConfig: {
    autoHighlight: true,
    minZoom: 15,
    rootCategory: ConstraintsCategory.ADOPTED_ROADS,
    categorySchema: [
      { key: "highway_maintenance_public" },
      { key: "highway_maintenance_prospective" },
      { key: "highway_maintenance_nonpublic" },
      { key: "highway_maintenance_unclassified" },
    ],
  },
};

// Map layer only, display both road names and traffic counts
export const ROAD_AND_TRAFFIC_COUNTS: Layer = {
  id: "ROAD_AND_TRAFFIC_COUNTS",
  layerType: RoadAndTrafficLayerType,
  title: "Road & Traffic counts",
  requiredFeatureAccess: [Feature.roadsAndTrafficLayer],
  toggleable: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  group: LayerGroup.TRAFFIC,
  icon: "lt-layer-road-traffic-counts",
  description: "Road and traffic volumes by vehicle",
  hideByDefault: true,
  zoomConfig: {
    minVisualisationZoom: 10,
  },
  layerConfig: {
    rootCategory: ConstraintsCategory.ROADS_AND_TRAFFIC,
    categorySchema: [
      { key: "open_roads_m" },
      { key: "traffic_counts_m" },
      { key: "open_roads_a" },
      { key: "traffic_counts_a" },
      { key: "open_roads_b" },
      { key: "traffic_counts_b" },
      { key: "open_roads_c" },
      { key: "open_roads_u" },
      { key: "traffic_counts_c_u" },
    ],
  },
};

// Assessment only - used to focus purely on the traffic counts without the nearby road names
export const TRAFFIC_COUNTS: Layer = {
  id: "TRAFFIC_COUNTS",
  layerType: TrafficLayerType,
  title: "Traffic counts",
  requiredFeatureAccess: [Feature.roadsAndTrafficLayer],
  toggleable: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  group: LayerGroup.TRAFFIC,
  icon: "lt-layer-road-traffic-counts",
  description: "Road and traffic volumes by vehicle",
  layerConfig: {
    rootCategory: ConstraintsCategory.ROADS_AND_TRAFFIC,
    categorySchema: [
      { key: "traffic_counts_m" },
      { key: "traffic_counts_a" },
      { key: "traffic_counts_b" },
      { key: "traffic_counts_c_u" },
    ],
  },
};
